import { prepareForSlot } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

type ModalBackdropProps = ComponentProps<'div'> & {
  open: boolean
}

const ModalBackdropSlot = prepareForSlot(function ModalBackdrop(
  props: ModalBackdropProps,
): JSX.Element {
  const {
    className,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Passed from root component but not needed for rendering
    open,
    ...rest
  } = props

  return <div className={clsx('modal__backdrop', className)} {...rest} />
})

export const ModalBackdrop = ModalBackdropSlot
